import { render, staticRenderFns } from "./SwipeAnimation.vue?vue&type=template&id=5d4fdb62&scoped=true"
import script from "./SwipeAnimation.vue?vue&type=script&lang=js"
export * from "./SwipeAnimation.vue?vue&type=script&lang=js"
import style0 from "./SwipeAnimation.vue?vue&type=style&index=0&id=5d4fdb62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4fdb62",
  null
  
)

export default component.exports